// @TODO: Remove this and pass and use tracking Id from Person context
export const personNotesTrackingIds = {
  cancelBtn: 'person-selector-person-notes-cancel-btn',
};
